import React, { useMemo } from 'react'
import { makeStyles, TextField } from '@material-ui/core'
import { IFormElementHelperProps } from './helpers'

// Some common props for the material Autocomplete component
export const useAutocompleteConfig = ({
  alwaysOpen,
  ...inputParams
}: {
  alwaysOpen?: boolean
  autoFocus?: boolean
} & IFormElementHelperProps) => {
  const { wrapper, popperDisablePortal } = useStyles()
  const config = useMemo(() => ({
    ...(alwaysOpen === true ? {
      open: true,
      disablePortal: true,
    } : {} ),
    disabled: inputParams.disabled,
    classes: { popperDisablePortal },
    className: wrapper,
    renderInput: (params: any) => <TextField {...params} {...inputParams} variant="outlined" autoComplete="off" />,
  }), [alwaysOpen, inputParams])

  return config
}

const useStyles = makeStyles({
  wrapper: {
    minWidth: 300,
  },
  popperDisablePortal: {
    position: 'relative',
  },
})
